module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/lock-7cb87585552e4543342ca57ade30800b.png";